import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { SELECT_LABELS, selectPlaceholder, withSelectPlaceholder } from '../../services/selectOptions';

const EXTINTA_OPTIONS = withSelectPlaceholder(
  [
    { value: 'S', label: 'Sí' },
    { value: 'N', label: 'No' },
  ],
  SELECT_LABELS.extinta
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatExtintaLabel(value) {
  if (value === 'S') return 'Sí';
  if (value === 'N') return 'No';
  return value || '—';
}

export class UpdateCarrera extends Component {
  static displayName = UpdateCarrera.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      anioImplementacion: '',
      name: '',
      resolucionMinisterial: '',
      extinta: '',
      valueExtinta: selectPlaceholder(SELECT_LABELS.extinta),
      errorMessage: '',
      redirect: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  async componentDidMount() {
    if (constantClass.canAccess('WWCarreras')) {
      await this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleFieldChange = (field) => (e) => {
    this.clearFeedback();
    this.setState({ [field]: e.target.value });
  };

  handleExtintaChange = (option) => {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({ valueExtinta: option, extinta: value });
  };

  isFormValid() {
    return (
      this.state.name.trim().length > 0
      && this.state.anioImplementacion.trim().length > 0
      && this.state.resolucionMinisterial.trim().length > 0
      && this.state.extinta.length > 0
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      this.setState({ redirect: true });
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveCarrera();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/Carreras/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(data, 'No se pudieron cargar los datos de la carrera.'),
      });
      return;
    }

    const model = data.returnModel;
    const extinta = (model.carreraExtinta || 'N').toString().trim();
    const selectedExtinta =
      EXTINTA_OPTIONS.find((x) => x.value === extinta) ||
      EXTINTA_OPTIONS.find((x) => x.value === 'N');

    this.setState({
      loadingInitial: false,
      anioImplementacion: model.carreraAnioImplementacion,
      name: model.carreraNombre.trim(),
      extinta,
      resolucionMinisterial: model.carreraResolucionAprobacion.trim(),
      valueExtinta: selectedExtinta,
    });
  }

  async saveCarrera() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/Carreras/', {
      method: 'POST',
      body: JSON.stringify({
        CarreraNombre: this.state.name.trim(),
        CarreraAnioImplementacion: this.state.anioImplementacion.trim(),
        CarreraResolucionAprobacion: this.state.resolucionMinisterial.trim(),
        CarreraExtinta: this.state.extinta,
        CarreraCod: parseInt(this.state.id, 10),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar la carrera. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-carreras" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      name,
      anioImplementacion,
      resolucionMinisterial,
      extinta,
      valueExtinta,
      errorMessage,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly ? 'Detalle de Carrera' : 'Modificar Carrera';

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-carreras">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-carreras">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-carreras">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados de la carrera.'
            : 'Actualice los datos de la carrera y confirme los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando cambios, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="carrera-nombre">
                Nombre Completo
              </label>
              <input
                id="carrera-nombre"
                className="md-form-page__input"
                type="text"
                value={name}
                onChange={this.handleFieldChange('name')}
                disabled={isBusy || this.isReadOnly}
                readOnly={this.isReadOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="carrera-anio">
                Año de Implementación
              </label>
              <input
                id="carrera-anio"
                className="md-form-page__input"
                type="text"
                value={anioImplementacion}
                onChange={this.handleFieldChange('anioImplementacion')}
                disabled={isBusy || this.isReadOnly}
                readOnly={this.isReadOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="carrera-resolucion">
                Resolución Ministerial
              </label>
              <input
                id="carrera-resolucion"
                className="md-form-page__input"
                type="text"
                value={resolucionMinisterial}
                onChange={this.handleFieldChange('resolucionMinisterial')}
                disabled={isBusy || this.isReadOnly}
                readOnly={this.isReadOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Carrera Extinta</span>
              {this.isReadOnly ? (
                <input
                  className="md-form-page__input"
                  type="text"
                  value={formatExtintaLabel(extinta)}
                  disabled
                  readOnly
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="carrera-extinta"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valueExtinta}
                    options={EXTINTA_OPTIONS}
                    onChange={this.handleExtintaChange}
                    isDisabled={isBusy}
                  />
                </div>
              )}
            </div>

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
